import { render, staticRenderFns } from "./TutorAssessmentRecognitionsStep.vue?vue&type=template&id=9425e024&scoped=true&"
import script from "./TutorAssessmentRecognitionsStep.vue?vue&type=script&lang=js&"
export * from "./TutorAssessmentRecognitionsStep.vue?vue&type=script&lang=js&"
import style0 from "./TutorAssessmentRecognitionsStep.vue?vue&type=style&index=0&id=9425e024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9425e024",
  null
  
)

export default component.exports